import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const ProteinCreationRoutes: RouteBundle = {
  domain: 'antibodies',
  routes: [
    {
      urlPattern: 'proteins/create',
      handler: EditorRoutes.proteinCreationFlow.bind(EditorRoutes),
    },
  ],
};
